import Vue from 'vue'
import VueX from 'vuex'

Vue.use(VueX)

const state = {
  languages: ['en', 'us', 'es', 'de', 'ja', 'zh', 'fr', 'it', 'pl', 'tr', 'pt', 'br', 'th', 'vn', 'cz', 'ko', 'ro'],
  available: [],
  snips: [],
  missing: []
}

const getters = {
}

const mutations = {
  SetAvailableLanguages (state, payload) {
    state.available = payload
  },
  SetLanguageSnips (state, payload) {
    state.snips = payload
  },
  SetMissingSnips (state, payload) {
    state.missing = payload
  },
  SaveNewSnip (state, payload) {
    state.snips.unshift(payload)
    state.missing.splice(0, 1)
  }
}

const store = new VueX.Store({
  state,
  getters,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/languages.js